import { motion } from 'framer-motion'
import { useInView } from './useInView'
import {
  Shield,
  Zap,
  Globe,
  Bell,
  Lock,
  Palette,
} from 'lucide-react'

const features = [
  {
    icon: Zap,
    title: 'Rezerwacja w sekundach',
    description:
      'Intuicyjny interfejs pozwala znalezc i zarezerwowac obiekt sportowy w kilka klikniec.',
    color: 'brand',
  },
  {
    icon: Shield,
    title: 'Bezpieczne platnosci',
    description:
      'Integracja z TPay zapewnia bezpieczne i szybkie platnosci online z pelna ochrona transakcji.',
    color: 'brand',
  },
  {
    icon: Globe,
    title: 'Wyszukiwanie lokalne',
    description:
      'Zaawansowane wyszukiwanie z mapa i filtrami pozwala znalezc obiekty w Twojej okolicy.',
    color: 'brand',
  },
  {
    icon: Bell,
    title: 'Powiadomienia push',
    description:
      'Przypomnienia o rezerwacjach, aktualizacje statusu platnosci i nowe oferty prosto na telefon.',
    color: 'accent',
  },
  {
    icon: Lock,
    title: 'Prywatnosc RODO',
    description:
      'Pelna zgodnosc z RODO. Kontrola nad danymi osobowymi i ustawieniami prywatnosci.',
    color: 'accent',
  },
  {
    icon: Palette,
    title: 'Panel dla biznesu',
    description:
      'Dedykowana aplikacja webowa dla wlascicieli obiektow z kalendarzem, statystykami i fakturami.',
    color: 'accent',
  },
]

export default function Features() {
  const { ref, isInView } = useInView()

  return (
    <section id="features" className="relative py-32">
      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-20"
        >
          <p className="text-brand-400 font-semibold text-sm tracking-widest uppercase mb-4">
            Funkcje
          </p>
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight mb-6">
            Wszystko czego potrzebujesz
          </h2>
          <p className="text-lg text-zinc-400 leading-relaxed">
            Od wyszukiwania obiektow po zarzadzanie platnosci - Spotto oferuje
            kompletne rozwiazanie dla sportowcow i wlascicieli obiektow.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.15 + i * 0.1 }}
              className={`group relative p-8 rounded-2xl border transition-all cursor-default ${
                feature.color === 'accent'
                  ? 'bg-white/[0.02] border-white/[0.06] hover:border-accent-500/20 hover:bg-white/[0.03]'
                  : 'bg-white/[0.02] border-white/[0.06] hover:border-brand-500/20 hover:bg-white/[0.03]'
              }`}
            >
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 transition-colors ${
                  feature.color === 'accent'
                    ? 'bg-accent-500/10 group-hover:bg-accent-500/20'
                    : 'bg-brand-600/10 group-hover:bg-brand-600/20'
                }`}
              >
                <feature.icon
                  size={24}
                  className={
                    feature.color === 'accent'
                      ? 'text-accent-400'
                      : 'text-brand-400'
                  }
                />
              </div>
              <h3 className="text-lg font-bold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
